import * as React from 'react';
import { ISVGProps } from './SVG';

export const RecordSVG = ({ width, height, title, fill }: ISVGProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22.56 22.56">
    <title>{title}</title>
    <path
      d="M19.25,3.3a11.19,11.19,0,0,0-8-3.3h0a11.28,11.28,0,0,0,0,22.56h0A11.29,11.29,0,0,0,22.56,11.27,11.16,11.16,0,0,0,19.25,3.3Zm1.1,8a9.06,9.06,0,1,1-9-9,9.07,9.07,0,0,1,9.05,9Z"
      fill={fill}
    />
    <circle cx="11.28" cy="11.28" r="6.49" fill={fill} />
  </svg>
);
